module.exports = __webpack_public_path__ + "static/media/tm-colorit-6-sm.57646bb8.webp";